import styles from './contact.module.scss'

const PrivacyContact: React.FC = () => {
  return (
    <article className={styles.privacy_page}>
      <section className={styles.title_group}>
        <h2 className={styles.title}>個人情報の取り扱いについて</h2>
      </section>
      <ul>
        <li>
          <p className={styles.list_title}>（１）事業者の氏名または名称</p>
          <p className={styles.list_text}>Aitria株式会社</p>
        </li>
        <li>
          <p className={styles.list_title}>
            （２）個人情報保護管理者（若しくはその代理人）の氏名又は職名、所属及び連絡先
          </p>
          <p className={styles.list_text}>
            個人情報保護管理者：大森 康宏
            <br />
            電子メール：pms_mgmt@aitria.co.jp
            <br />
            電話番号：03-6419-7700
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（３）個人情報の利用目的</p>
          <p className={styles.list_text}>
            <span>・お問い合わせ情報</span>
            <span className={styles.list_text_colon}>：</span>
            お問い合わせいただいた内容に回答するため、メルマガ配信のため。
            <br />
            <span>・セミナー申込情報</span>
            <span className={styles.list_text_colon}>：</span>
            お申込みいただいたセミナー運営、連絡のため、メルマガ配信のため。
            <br />
            <span>・資料請求情報</span>
            <span className={styles.list_text_colon}>：</span>お求めいただいた資料を送付するため、メルマガ配信のため。
            <br />
            <span>・寄付者情報（氏名）</span>
            <span className={styles.list_text_colon}>：</span>
            メディアへ支援者として掲載するため。（許諾いただいた場合のみ）
            <br />
            <span className={styles.right}>（連絡先）</span>
            <span className={styles.list_text_colon}>：</span>寄付完了連絡のため。（必要な場合のみ）
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（４）個人情報の第三者提供について</p>
          <p className={styles.list_text}>取得した個人情報は法令等による場合を除いて第三者に提供することはありません</p>
        </li>
        <li>
          <p className={styles.list_title}>（５）個人情報の取扱いの委託について</p>
          <p className={styles.list_text}>
            取得した個人情報の取扱いの全部又は、一部を業務遂行の範囲内で委託することがあります。
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（６）個人情報を与えなかった場合に生じる結果</p>
          <p className={styles.list_text}>
            個人情報を与えることは任意です。個人情報に関する情報の一部をご提供いただけない場合は、お問い合わせ内容に回答できない可能性があります。
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（７）保有個人データの開示等および問い合わせ窓口について</p>
          <p className={styles.list_text}>
            ご本人からの求めにより、当社が保有する保有個人データに関する開示、利用目的の通知、内容の訂正・追加または削除、利用停止、消去および第三者提供の停止(以下、開示等という)に応じます。
            <br />
            開示等に応ずる窓口は、下記「当社の個人情報の取扱いに関する苦情、相談等の問合せ先」を参照してください。
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（８）本人が容易に認識できない方法による個人情報の取得</p>
          <p className={styles.list_text}>
            クッキーやウェブビーコン等を用いるなどして、本人が容易に認識できない方法による個人情報の取得を行っております。
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（９）個人情報の安全管理措置について</p>
          <p className={styles.list_text}>
            取得した個人情報については、漏洩、減失またはき損の防止と是正、その他個人情報の安全管理のために必要かつ適切な措置を講じます。
            <br />
            お問合せへの回答後、取得した個人情報は当社内において削除致します
          </p>
        </li>
        <li>
          <p className={styles.list_title}>（１０）個人情報保護方針</p>
          <p className={styles.list_text}>当社ホームページの個人情報保護方針をご覧下さい。</p>
        </li>
        <li>
          <div>
            <p className={styles.list_title}>（１１）当社の個人情報の取扱いに関する苦情、相談等の問合せ先</p>
            <table className={styles.bottom_table}>
              <thead>
                <tr className={styles.table_column_title}>
                  <th className={styles.th}>窓口の名称</th>
                  <td className={styles.td}>個人情報問合せ窓口</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className={styles.th}>連絡先</th>
                  <td className={styles.td}>
                    <p>窓口責任者：個人情報保護管理者</p>
                    <p>住所：〒107-0052 東京都港区赤坂八丁目１番22号 NMF青山一丁目ビル３階</p>
                    <p>電話/FAX：03-6419-7700 / 03-6419-7703</p>
                    <p>電子メール：pms_mgmt@aitria.co.jp</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
      </ul>
    </article>
  )
}

export default PrivacyContact
